export const TAG_SERIAL_TYPES = {
  sequence: 1,
  codified: 2
};
